import { WizardItem } from '../Interfaces/Wizard.interface';
import { WizardItemType } from '../Enums/WizardItemType.enum';

const BASE_ITEM_DATA = {
	id: '',
	parentId: '',
	rank: 0,
	wizardId: '',
	children: null,
	value: null,
	data: null,
	subtype: null,
};

export const addWizardTextField = (): Extract<
	WizardItem,
	{ type: WizardItemType.TEXT_FIELD | WizardItemType.TEXT_FIELD_2 }
> => {
	return {
		...BASE_ITEM_DATA,
		key: 'textFieldKey',
		type: WizardItemType.TEXT_FIELD,
		title: 'textFieldLabel',
		settings: { required: false },
	};
};

export const addWizardSelect = (): Extract<
	WizardItem,
	{ type: WizardItemType.SELECT }
> => {
	return {
		...BASE_ITEM_DATA,
		type: WizardItemType.SELECT,
		key: 'selectKey',
		title: 'selectLabel',
		settings: { required: false },
		children: [
			{
				...BASE_ITEM_DATA,
				type: WizardItemType.ITEM,
				key: 'selectOption1',
				title: 'selectOption1',
				value: '1',
				settings: null,
			},
			{
				...BASE_ITEM_DATA,
				type: WizardItemType.ITEM,
				key: 'selectOption2',
				title: 'selectOption2',
				value: '2',
				settings: null,
			},
		],
	};
};

export const addWizardRadioList = (): Extract<
	WizardItem,
	{ type: WizardItemType.RADIO_LIST }
> => {
	return {
		...BASE_ITEM_DATA,
		type: WizardItemType.RADIO_LIST,
		key: 'radioListKey',
		title: 'radioListLabel',
		settings: { required: false },
		children: [
			{
				...BASE_ITEM_DATA,
				type: WizardItemType.ITEM,
				key: 'radioListOption1',
				title: 'radioListOption1',
				value: '1',
				settings: null,
			},
			{
				...BASE_ITEM_DATA,
				type: WizardItemType.ITEM,
				key: 'radioListOption2',
				title: 'radioListOption2',
				value: '2',
				settings: null,
			},
		],
	};
};

export const addWizardDatePicker = (): Extract<
	WizardItem,
	{ type: WizardItemType.DATE }
> => {
	return {
		...BASE_ITEM_DATA,
		key: 'date',
		type: WizardItemType.DATE,
		title: 'datePickerLabel',
		settings: { required: false },
	};
};

export const addWizardSubmitButton = (): Extract<
	WizardItem,
	{ type: WizardItemType.SUBMIT_BUTTON }
> => {
	return {
		...BASE_ITEM_DATA,
		key: 'submitButton',
		type: WizardItemType.SUBMIT_BUTTON,
		title: 'submitButtonLabel',
		settings: null,
		data: {
			nextStep: 'nextStepKey',
		},
	};
};
